export default "__VITE_ASSET__Mv2Xcf2I__"